import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=be11a3ca&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=be11a3ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be11a3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be11a3ca')) {
      api.createRecord('be11a3ca', component.options)
    } else {
      api.reload('be11a3ca', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=be11a3ca&scoped=true&", function () {
      api.rerender('be11a3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CINoTXJh4Uly/JS/comp/CookieBox.vue"
export default component.exports